import React from "react";
import { Link, useLocation } from "react-router-dom";
import profileImg from "../images/profile.jpg";
import resume from "../images/resume.png";


const Avatar = () => {
  const {pathname} = useLocation();
  console.log(pathname)
  return (
    <div className="avatar">
      <Link to="/">
        {" "}
        <img src={profileImg} alt="" />
      </Link>
      <div className="resume">
        <a href="https://drive.google.com/file/d/1vYK03uZG_dgOqGZ-EnUa_E1vP1K0aWl1/view?usp=sharing" target="_blank">
          {" "}
          <img src={resume} alt="resume" /> <span>View Resume</span>
        </a>
      </div>

      {/* {
        pathname !== '/' && <Link className="back-btn" to={'/'}> <img src={back} alt="" /> Back</Link>
      } */}
      {/*<div className="social-links">
        <ul>
          <li>
            <a href="" target="_blank">
              {" "}
              <img src={linkedin} alt="" />
            </a>
          </li>
          <li>
            <a href="" target="_blank">
              {" "}
              <img src={github} alt="" />
            </a>
          </li>
          <li>
            <a href="" target="_blank">
              {" "}
              <img src={facebook} alt="" />
            </a>
          </li>
        </ul>
      </div> */}
    </div>
  );
};

export default Avatar;
